import PropTypes from 'prop-types';
import cn from 'classnames';

import { analytics, getClickCtaDetail } from '@/utils/analytics';
import { getContent } from '@/utils/helper';

import Text from '@/atoms/Text/Text';
import CtfCta from '@/molecules/CTA/index';

function ProductDetail({ entries, fields }) {
  let {
    breed,
    feed,
    experience,
    story,
    callToActions,
    marbleScores,
    leftBackgroundColor,
    rightBackgroundColor,
  } = fields;

  const marbleScoreList =
    marbleScores?.length > 0
      ? marbleScores.map((marbleScore) => {
          const marbleScoreContent = getContent(marbleScore.sys.id, entries)?.fields;
          return {
            ...marbleScoreContent,
          }
        })
      : [];

  return (
    <div className="flex flex-col md:flex-row w-full">
      <div className={cn("flex md:w-1/2 justify-end", {
        "bg-eucalyptus": leftBackgroundColor === "Eucalyptus",
        "bg-warm-grey": leftBackgroundColor === "Warm Grey",
        "bg-white": leftBackgroundColor === "White",
      })}>
        <div className="flex flex-col w-full px-5 py-10 md:max-w-[768px] md:pr-[85px] md:pl-[48px] lg:pl-[64px] md:py-[76px]">
          <div className="flex flex-col">
            <Text tag="h5" style="text-black mb-4">Breed</Text>
            <Text tag="body-large" style="text-black !text-body md:!text-body-large">{breed}</Text>
          </div>
          <div className="flex flex-col mt-10">
            <Text tag="h5" style="text-black mb-4">Feed</Text>
            <Text tag="body-large" style="text-black !text-body md:!text-body-large">{feed}</Text>
          </div>
          <div className="mt-10">
            <Text tag="h5" style="text-black mb-4">Experience</Text>
            <Text tag="body-large" style="text-black !text-body md:!text-body-large">{experience}</Text>
          </div>
          <div className="mt-10">
            <Text tag="h5" style="text-black mb-4">Story</Text>
            <Text tag="body-large" style="text-black !text-body md:!text-body-large">{story}</Text>
          </div>
          {callToActions && callToActions.length > 0 && (
            <div className="flex flex-row gap-5 mt-10">
              {callToActions.map((item, index) => {
                return (
                  <CtfCta
                    key={index}
                    field={item}
                    entries={entries}
                    onClick={(e, { localUrl, url, name }) =>
                      analytics({
                        window,
                        document,
                        detail: getClickCtaDetail(e, { localUrl, url, name }),
                      })
                    }
                  />
                )
              })}
            </div>
          )}
        </div>
      </div>
      <div className={cn("flex md:w-1/2 justify-start", {
        "bg-millet": rightBackgroundColor === "Pure",
        "bg-sorghum": rightBackgroundColor === "Cross",
        "bg-cooper-clover": rightBackgroundColor === "Grass",
        "bg-warm-grey": rightBackgroundColor === "Warm Grey",
        "bg-eucalyptus": rightBackgroundColor === "Eucalyptus",
      })}>
        <div className="flex flex-col w-full px-5 py-10 md:max-w-[768px] md:pl-[85px] md:pr-[48px] lg:pr-[64px] md:py-[76px]">
          <Text tag="h5" style={`mb-10 ${rightBackgroundColor === "Cross" || rightBackgroundColor === "Grass" ? "text-white" : "text-black"}`}>Marble Score</Text>
          <hr className={rightBackgroundColor === "Cross" || rightBackgroundColor === "Grass" ? "border-white" : "border-black"} />
          {marbleScoreList && marbleScoreList.length > 0 && (
            marbleScoreList.map((item, index) => {
              return (
                <div key={index}>
                  <div className="flex flex-row md:flex-col gap-9 md:gap-0">
                    <Text tag="h5" style={`hidden md:block my-10 ${rightBackgroundColor === "Cross" || rightBackgroundColor === "Grass" ? "text-white" : "text-black"}`}>{`${item.score} ${item.title}`}</Text>
                    <Text tag="h5" style={`w-full min-w-[55px] md:hidden my-[15px] ${rightBackgroundColor === "Cross" || rightBackgroundColor === "Grass" ? "text-white" : "text-black"}`}>{`${item.score}`}</Text>
                    <div className="w-full mb-[15px] md:mb-10">
                      <Text tag="h5" style={`md:hidden my-[15px] ${rightBackgroundColor === "Cross" || rightBackgroundColor === "Grass" ? "text-white" : "text-black"}`}>{item.title}</Text>
                      <Text tag="body-large" style={`${rightBackgroundColor === "Cross" || rightBackgroundColor === "Grass" ? "text-white" : "text-black"}  !text-body md:!text-body-large`}>{item.description}</Text>
                    </div>
                  </div>
                  <hr className={rightBackgroundColor === "Cross" || rightBackgroundColor === "Grass" ? "border-white" : "border-black"} />
                </div>
              )
            })
          )}
        </div>
      </div>
    </div>
  );
}

ProductDetail.propTypes = {
  entries: PropTypes.array,
  fields: PropTypes.object,
};

ProductDetail.defaultProps = {
  entries: [],
  fields: null,
};

export default ProductDetail;
